import {
  getAdminControllerFetchUsersQueryOptions,
  useAdminControllerFetchUsers,
} from "@/api/generated/okami";
import { useSendUrlsToOkamiScrapperMutation } from "@/api/send-urls-to-okami-scrapper";

import { createFileRoute } from "@tanstack/react-router";
import { chain } from "lodash";
import {
  OkamiScrapperForm,
  SendOkamiScrapperFormData,
} from "./-components/okami-scrapper-form";

const queryParams = {
  page: 1,
  limit: 100,
};

export const Route = createFileRoute("/_app/admin/okami-scrapper")({
  component: OkamiScrapper,
  loader: ({ context }) => {
    return context.queryClient.prefetchQuery(
      getAdminControllerFetchUsersQueryOptions(queryParams),
    );
  },
});

function OkamiScrapper() {
  const { data: users } = useAdminControllerFetchUsers(queryParams);
  const { mutate, isPending } = useSendUrlsToOkamiScrapperMutation();

  function handleSendToOkamiScrapper(data: SendOkamiScrapperFormData) {
    mutate({
      urls: data.urls,
      userId: data.userId,
    });
  }

  const usersOptions = chain(users?.data ?? [])
    .filter((user) => ["ADMIN", "SUBSCRIBED_USER"].includes(user.role))
    .map((user) => ({
      label: user.email,
      value: user.id,
    }))
    .value();

  return (
    <section className="flex flex-col gap-4">
      <h1 className="text-center text-3xl font-bold tracking-tighter md:text-left">
        Okami Scrapper
      </h1>

      <p className="text-center text-sm text-gray-500 md:text-left">
        Enviar batch de urls de obras para o Okami Scrapper
      </p>

      <OkamiScrapperForm
        handleSubmit={handleSendToOkamiScrapper}
        isPending={isPending}
        usersOptions={usersOptions}
      />
    </section>
  );
}
